// extracted by mini-css-extract-plugin
export var carrierIcon = "_wj-0";
export var carrierLogo = "_wj-1";
export var detailsSection = "_wj-2";